// extracted by mini-css-extract-plugin
export default {"kebab-button":"KebabButton_kebab-button__wvD7E"};